import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../claimCheckPageStyle.js";
import { regulationDocuments } from "../regulationDocuments";

const useStyles = makeStyles(styles);

export default function RegulationPdfSection({ t }) {
  const classes = useStyles();
  const documents = regulationDocuments(t);
  return (
    <div className={classes.pdfSection}>
      <div className={classes.pdfList}>
        {documents.map((doc) => (
          <div className={classes.pdfInner} key={doc.url}>
            <div className={classes.pdfIcon}>PDF</div>
            <div className={classes.pdfInfo}>
              <p className={classes.pdfTitle}>{doc.title}</p>
              <p className={classes.pdfSubtitle}>{doc.subtitle}</p>
            </div>
            <a
              href={doc.url}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.pdfButton}
            >
              {t.pdfDownload}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
